import Immutable from 'immutable';
import * as actions from './actions';

const sound = (state = Immutable.Map({ play: false }), action) => {
  switch (action.type) {
    case actions.CHAT_SOUND_PLAY: {
      return state.set('play', true);
    }
    case actions.CHAT_SOUND_DONE: {
      return state.set('play', false);
    }
    default: {
      return state;
    }
  }
};

export default sound;
